export enum PagePermaLink {
  ACTIVITIES = 'activities',
  COMPANIES = 'companies',
  DOCUMENTS = 'documents',
  DASHBOARD = 'dashboard',
  LEADS = 'leads',
  // The Lists/Segments overview page is served at the CMS permalink `segments`.
  LISTS = 'segments',
  MY_WORK = 'my-work',
  MY_CONTACTS = 'my-contacts',
  OPPORTUNITIES = 'opportunities',
  ORDERS = 'orders',
  PERSONS = 'persons',
  QUOTES = 'quotes',
  SEARCH_RESULTS = 'search-results',
  TICKETS = 'tickets',
  TIME_TRACKING = 'time-tracking',
}

export const INSTANCE_APP_ROUTE_PATH = '/i'

export const PISA_GID_REGEXP = /^[A-F0-9]{32}$/
